<template>
  <div>
    <!-- Header avec titre -->
    <div class="text-center mb-8">
      <div class="text-4xl font-maxime text-white text-center mb-4">
        {{ selectedTheme ? selectedTheme.title : $t('themes') }}
      </div>
    </div>
    
    <!-- PhotoWall pour afficher les thèmes OU les photos d'un thème -->
    <PhotoWall 
      ref="photoWall"
      :images="displayImages" 
      :show-titles="!selectedTheme"
      :show-back-button="!!selectedTheme"
      :back-button-text="'Retour aux thèmes'"
      @image-click="onImageClick"
      @back="goBackToThemes"
    />
  </div>
</template>

<script>

import { fetchS3Json, listS3Objects } from '../utils/s3';
import PhotoWall from '../components/PhotoWall.vue';

export default {
  components: { PhotoWall },
  data() {
    return {
      selectedTheme: null, // Thème actuellement sélectionné
      selectedThemeImages: [], // Images du thème sélectionné
      themesList: [],
      themePreviews: {}
    };
  },
  computed: {
    themes() {
      return this.themesList.map((theme) => {
          return theme || null;
      });
    },
    
    // Images pour le mur principal (aperçus des thèmes)
    themeImages() {
      return this.themes.map(theme => {
        const themeImage = this.themePreviews[theme.key];
        return {
          src: themeImage, // Première image du thème
          title: this.$t(`topics.${theme.key}`),
          themeKey: theme.key,
          isThemePreview: true
        };
      }).filter(item => item.src); // Filtrer les thèmes sans images
    },

    // Images à afficher : thèmes ou photos d'un thème sélectionné
    displayImages() {
      if (this.selectedTheme) {
        return this.selectedThemeImages.map(src => ({ src }));
      }
      return this.themeImages;
    }
  },
  async mounted() {
    await this.loadThemes();
    await this.loadThemePreviews();
  },
  methods: {
    async loadThemes() {
      const data = await fetchS3Json('themes.json', { themes: [] });
      this.themesList = Array.isArray(data?.themes) ? data.themes : [];
    },
    async loadThemePreviews() {
      const previews = {};

      await Promise.all(
        this.themes.map(async (theme) => {
          const images = await listS3Objects(`themes/${theme.key}/`);
          previews[theme.key] = images[0] || null;
        })
      );

      this.themePreviews = previews;
    },
    onImageClick(image) {
      if (this.selectedTheme) {
        // Si on est dans la vue d'un thème, ouvrir la modal normale
        // La modal sera gérée par PhotoWall automatiquement
        return;
      } else if (image.isThemePreview) {
        // Si on clique sur un aperçu de thème, afficher toutes les photos du thème
        this.showThemePhotos(image);
      }
    },

    async showThemePhotos(themeImage) {
      this.selectedTheme = {
        key: themeImage.themeKey,
        title: themeImage.title
      };
      this.selectedThemeImages = await this.getIllustrations(themeImage.themeKey);
      console.log(`Affichage de ${this.selectedThemeImages.length} photos pour le thème: ${themeImage.title}`);
    },

    goBackToThemes() {
      this.selectedTheme = null;
      this.selectedThemeImages = [];
    },
    
    async getIllustrations(key) {
      return await listS3Objects(`themes/${key}/`);
    }
  }
}
</script>
